export const LOAD_REWARD = 'LOAD_REWARD';
export const LOAD_REWARDS = 'LOAD_REWARDS';
export const REDEEMED_REWARD = 'REDEEMED_REWARD';
